<template>
  <fieldset class="groupedfield">
    
    <legend class="groupedfield__text label">
      {{schema.title}}
    </legend>

    <sc-tooltip v-if="schema.tooltip" type="is-light" position="is-right"
      :label="schema.tooltip">

      <sc-icon size="is-small" icon="info-circle" />
    </sc-tooltip>

    <base-form ref="baseForm"
      :fields="schema.fields" :warehouseId="warehouseId"
      v-model="value" @change="onChange" />

  </fieldset>
</template>

<script>
import {
  ScTooltip,
  ScIcon,
} from '@intelipost-js/secure-components';

export default {
  name: 'group-field',
  components: {
    ScTooltip,
    ScIcon,
    'base-form': () => import('../base/BaseForm.vue'),
  },
  props: {
    schema: {
      type: Object,
      required: true,
    },
    warehouseId: {
      type: Number,
      required: false,
    },
    value: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {

    validate() {
      return this.$refs.baseForm.validate();
    },

    onChange() {
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss" scoped>
  .groupedfield {
    border: 1px solid lightgrey; 
    padding: 5px;

    &__text {
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/fields/GroupField.vue?2a8fb9d6